export default __webpack_public_path__ + "static/media/type2.4096b731.png";